module.exports = __webpack_public_path__ + "static/img/08.2becb1a1.png";